import React from 'react';
import Select from 'react-select';

const statusOptions = [
  { value: 'Needs Service', label: 'Needs Service' },
  { value: 'OK', label: 'OK' },
  { value: 'Missed', label: 'Missed' },
  { value: 'Resolved', label: 'Resolved' },
  { value: 'All Status', label: 'All Status' }
];

const STATUS_COLORS = {
  'Needs Service': { bg: '#ffebee', fg: '#dc3545', hoverBg: '#ffcdd2' },
  'Missed':        { bg: '#fff3e6', fg: '#d97706', hoverBg: '#ffe2bf' },
  'No Access':     { bg: '#fff3e6', fg: '#d97706', hoverBg: '#ffe2bf' },
  'All Status':    { bg: '#eef6ff', fg: '#1f5eec', hoverBg: '#cce0ff' },
  'All Statuses':  { bg: '#eef6ff', fg: '#1f5eec', hoverBg: '#cce0ff' },
  'Pending':       { bg: '#f1f5f9', fg: '#64748b', hoverBg: '#e2e8f0' },
  __default:       { bg: '#e8f5e9', fg: '#28a745', hoverBg: '#c8e6c9' },
};

const colorsFor = (value) => STATUS_COLORS[value] || STATUS_COLORS.__default;

const customStyles = {
  control: (base) => ({
    ...base,
    backgroundColor: '#fff',
    borderRadius: '8px',
    border: 'none',
    boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
    minHeight: '48px',
    ':hover': { border: 'none' },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '0 8px',
  }),
  multiValue: (base, { data }) => ({
    ...base,
    backgroundColor: colorsFor(data.value).bg,
    borderRadius: '4px',
  }),
  multiValueLabel: (base, { data }) => ({
    ...base,
    color: colorsFor(data.value).fg,
    fontWeight: 700,
  }),
  multiValueRemove: (base, { data }) => ({
    ...base,
    color: colorsFor(data.value).fg,
    ':hover': {
      backgroundColor: colorsFor(data.value).hoverBg,
      color: colorsFor(data.value).fg,
    },
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: '#999',
    ':hover': {
      color: '#666',
    },
  }),
  clearIndicator: (base) => ({
    ...base,
    color: '#999',
    ':hover': {
      color: '#666',
    },
  }),
};

// Backwards compatible: parent may pass `statusFilter` as a string OR as an array.
//  - String mode: callback receives a string (last-selected wins).
//  - Array mode:  callback receives an array of statuses (true multi-select).
function StatusMultiSelect({ statusFilter, setStatusFilter, options = statusOptions, allStatusValue = 'All Status', ariaLabel }) {
  const isArrayMode = Array.isArray(statusFilter);

  const selectedValues = isArrayMode
    ? statusFilter
    : (statusFilter ? [statusFilter] : []);

  const selectedOption = selectedValues.map((v) => ({ value: v, label: v }));

  const emit = (values) => {
    if (isArrayMode) {
      setStatusFilter(values);
    } else {
      setStatusFilter(values[values.length - 1] || allStatusValue);
    }
  };

  const handleChange = (selected) => {
    const next = (selected || []).map((opt) => opt.value);

    if (next.length === 0) {
      emit([allStatusValue]);
      return;
    }

    // "All Status" is mutually exclusive with everything else.
    const justAddedAll = next.includes(allStatusValue) && !selectedValues.includes(allStatusValue);
    if (justAddedAll) {
      emit([allStatusValue]);
      return;
    }
    if (next.includes(allStatusValue) && next.length > 1) {
      emit(next.filter((v) => v !== allStatusValue));
      return;
    }

    emit(next);
  };

  return (
    <Select
      isMulti
      aria-label={ariaLabel || 'Filter by status'}
      options={options}
      value={selectedOption}
      onChange={handleChange}
      placeholder="Filter By Status..."
      styles={customStyles}
      closeMenuOnSelect={!isArrayMode}
      hideSelectedOptions={false}
      components={{
        IndicatorSeparator: () => null
      }}
    />
  );
}

export default StatusMultiSelect;
